import { XIcon } from "@phosphor-icons/react/dist/csr/X";
import { Fragment, type ReactNode } from "react";
import { Button } from "@volca/ui/components/ui/button";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";

export const DetailPanelHeader = ({
  title,
  facts,
  statuses,
  aside,
  onClose,
  children,
}: {
  title: ReactNode;
  facts: ReactNode[];
  statuses?: ReactNode;
  aside?: ReactNode;
  onClose: () => void;
  children?: ReactNode;
}) => {
  const shownFacts = facts.filter(Boolean);

  return (
    <Stack
      align="start"
      gap={6}
      className="w-full flex-none bg-surface px-5 py-6"
    >
      <Stack
        className="w-full"
        direction="row"
        justify="between"
        align="start"
        gap={4}
      >
        <Stack align="start" gap={1} className="min-w-0">
          <Text variant="display" render={<h2 />}>
            {title}
          </Text>
          <Stack
            direction="row"
            gap={2}
            align="center"
            className="flex-wrap text-sm text-subtle"
          >
            {shownFacts.map((fact, index) => (
              <Fragment key={index}>
                {index > 0 && <span aria-hidden>·</span>}
                {fact}
              </Fragment>
            ))}
          </Stack>
        </Stack>
        <Button
          variant="ghost"
          size="icon"
          aria-label="Close document details"
          onClick={onClose}
        >
          <XIcon aria-hidden />
        </Button>
      </Stack>
      {(statuses || aside) && (
        <Stack
          direction="row"
          justify="between"
          align="center"
          gap={2}
          className="w-full flex-wrap"
        >
          <Stack direction="row" gap={2} align="center" className="flex-wrap">
            {statuses}
          </Stack>
          {aside}
        </Stack>
      )}
      {children}
    </Stack>
  );
};
